import * as fromDataType from '../datatype-library/index'

export interface app_perm_template_request_line_RowInterface{
    guid: fromDataType.GuidDataFieldInterface;
    request_hdr_guid: fromDataType.GuidDataFieldInterface;
    namespace: fromDataType.VarcharDatatypeInterface;
    description: fromDataType.TextDatatypeInterface;
    code: fromDataType.VarcharDatatypeInterface;
    name: fromDataType.VarcharDatatypeInterface;
    type: fromDataType.VarcharDatatypeInterface;
    target_type: fromDataType.VarcharDatatypeInterface;
    operation_options_json: fromDataType.JsonDatatypeInterface;
    operation_default_json: fromDataType.JsonDatatypeInterface;
    target_options_json: fromDataType.JsonDatatypeInterface;
    property_json: fromDataType.JsonDatatypeInterface;
    module_guid: fromDataType.GuidDataFieldInterface;
    applet_guid: fromDataType.GuidDataFieldInterface;
    created_by_subject_guid: fromDataType.GuidDataFieldInterface;
    updated_by_subject_guid: fromDataType.GuidDataFieldInterface;
    created_date: fromDataType.TimestampTzDatatypeInterface;
    updated_date: fromDataType.TimestampTzDatatypeInterface;
    status: fromDataType.VarcharDatatypeInterface;
    revision: fromDataType.GuidDataFieldInterface;
    vrsn: fromDataType.VarcharDatatypeInterface;
    status_approval: fromDataType.VarcharDatatypeInterface;
    request_remarks: fromDataType.VarcharDatatypeInterface;
    process_remarks: fromDataType.VarcharDatatypeInterface;
    notification_status: fromDataType.VarcharDatatypeInterface;
    process_by_guid: fromDataType.GuidDataFieldInterface;
    process_date: fromDataType.TimestampTzDatatypeInterface;
}

export class app_perm_template_request_line_RowClass implements app_perm_template_request_line_RowInterface{
    guid: fromDataType.GuidDataFieldInterface;
    request_hdr_guid: fromDataType.GuidDataFieldInterface;
    namespace: fromDataType.VarcharDatatypeInterface;
    description: fromDataType.TextDatatypeInterface;
    code: fromDataType.VarcharDatatypeInterface;
    name: fromDataType.VarcharDatatypeInterface;
    type: fromDataType.VarcharDatatypeInterface;
    target_type: fromDataType.VarcharDatatypeInterface;
    operation_options_json: fromDataType.JsonDatatypeInterface;
    operation_default_json: fromDataType.JsonDatatypeInterface;
    target_options_json: fromDataType.JsonDatatypeInterface;
    property_json: fromDataType.JsonDatatypeInterface;
    module_guid: fromDataType.GuidDataFieldInterface;
    applet_guid: fromDataType.GuidDataFieldInterface;
    created_by_subject_guid: fromDataType.GuidDataFieldInterface;
    updated_by_subject_guid: fromDataType.GuidDataFieldInterface;
    created_date: fromDataType.TimestampTzDatatypeInterface;
    updated_date: fromDataType.TimestampTzDatatypeInterface;
    status: fromDataType.VarcharDatatypeInterface;
    revision: fromDataType.GuidDataFieldInterface;
    vrsn: fromDataType.VarcharDatatypeInterface;
    status_approval: fromDataType.VarcharDatatypeInterface;
    request_remarks: fromDataType.VarcharDatatypeInterface;
    process_remarks: fromDataType.VarcharDatatypeInterface;
    notification_status: fromDataType.VarcharDatatypeInterface;
    process_by_guid: fromDataType.GuidDataFieldInterface;
    process_date: fromDataType.TimestampTzDatatypeInterface;
}